import React, { FunctionComponent } from 'react'

import { NextPage } from 'next'

import { Header } from '@/components'
import { FooterContainer } from '@/containers'
import { Footer, HeaderMapper } from '@/service/api/footerHeader'

type BaseProps = {
  data: object
  footer: Footer
  header: HeaderMapper
}

export const withFooterHeader = (
  BaseComponent: FunctionComponent<any>,
): NextPage => {
  const PageComponent = ({ footer, header, data }: BaseProps) => (
    <>
      {header && <Header headerData={header} />}
      {data && <BaseComponent data={data} />}
      {footer && <FooterContainer footerData={footer} />}
    </>
  )

  return PageComponent as NextPage
}
